import { render, staticRenderFns } from "./AppButton.vue?vue&type=template&id=19b8529e&scoped=true"
import script from "./AppButton.vue?vue&type=script&lang=js"
export * from "./AppButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b8529e",
  null
  
)

export default component.exports